module.exports = __webpack_public_path__ + "img/footer-icon-row-light-toyota.44fc166c.png";